import React, {useEffect, useState} from "react";
import {Col, Row} from "react-bootstrap";
import {RequireAuth} from "Components/Security/RequireAuth";
import {DefaultContainer} from "Views/Shared/DefaultContainer";
import {useNavigate, useParams} from "react-router-dom";
import {Notificator} from "Services/Notificator/Notificator";
import {useMutation} from "react-query";
import {useAppDispatch} from "hooks";
import {appLoading} from "Store/loadingSlice";
import {EnrollmentForm} from "./EnrollmentForm";
import {createEnrollment} from "../../Api/Mutation/Enrollments";
import {ROUTE_PATHS} from "../../Config/Router/Routes";

export const EnrollmentCreate : React.FC = () => {

    const {id} = useParams()
    const navigate = useNavigate()
    const dispatch = useAppDispatch()

    const [entity, setEntity] = useState<any>({
        name: "",
        price: 0,
        enabled: false,
        activitySessions: []
    })

    const update = useMutation({
        mutationKey: [],
        mutationFn: (body: any) => createEnrollment(body.data),
        onSuccess: () => {
            Notificator.success('La matricula se ha creado correctamente')
            navigate(ROUTE_PATHS.ADMIN_ENROLLMENTS_LIST)
        },
        onError: () => {
            Notificator.error('Se ha producido un error al crear la matricula')
        }
    })

    const onSave = (data: any,) => {
        data = {
            ...data,
            price: parseFloat(data.price)
        }

        let finalData = data
        finalData = {
            ...finalData,
            activitySessions: data.activitySessions.map((item: any) => {
                return item.value
            })
        }

        update.mutate({
            id: id,
            data: finalData
        })
    }

    useEffect(() => {
        dispatch(appLoading({value: update.isLoading, text: 'Cargando'}))
    }, [update.isLoading])

    return (
        <RequireAuth>
            <DefaultContainer>

                <Col>

                    <Row>
                        <Col>
                            <h1 className={"pb-4"}>Crear matrícula</h1>
                        </Col>

                    </Row>

                    <Row>
                        <EnrollmentForm
                            onSave={onSave}
                            entity={entity}
                        />
                    </Row>

                </Col>

            </DefaultContainer>
        </RequireAuth>
    )
}
